import { envConfig } from '@/config/envConfig';
import { USER_ROLE_MAP, UserRoleType } from '@/const/user';
import { useUser } from '@/context/userContext';
import { useEffect, useState } from 'react';

const ALLOWED_ROLES: UserRoleType[] = [
  USER_ROLE_MAP.ORG_ADMIN,
  USER_ROLE_MAP.MASTER_ADMIN,
  USER_ROLE_MAP.EXECUTOR,
  USER_ROLE_MAP.DEPOSITOR,
  USER_ROLE_MAP.RECIPIENT,
];

const WIDGET_HTML_TAG = 'elevenlabs-convai';
const WIDGET_SCRIPT_ID = 'elevenlabs-script';
const WIDGET_ELEMENT_ID = 'elevenlabs-widget';

export const useSupportWidget = () => {
  const { currentRole } = useUser();
  const [initialized, setInitialized] = useState(false);

  const initWidget = () => {
    // Disable 11Labs widget for localhost
    if (window.location.hostname === 'localhost') {
      return;
    }

    if (!envConfig.ELEVEN_LABS_KEY || !ALLOWED_ROLES.includes(currentRole)) return;

    const script = document.createElement('script');

    script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
    script.id = WIDGET_SCRIPT_ID;
    script.async = true;

    document.body.appendChild(script);

    const widgetElement = document.createElement(WIDGET_HTML_TAG);

    widgetElement.setAttribute('id', WIDGET_ELEMENT_ID);
    widgetElement.setAttribute('agent-id', envConfig.ELEVEN_LABS_KEY);
    document.getElementById('root').appendChild(widgetElement);

    setInitialized(true);
  };

  const destroyWidget = () => {
    if (!envConfig.ELEVEN_LABS_KEY) return;

    const script = document.getElementById(WIDGET_SCRIPT_ID);
    const widgetElement = document.getElementById(WIDGET_ELEMENT_ID);

    setInitialized(false);

    if (script) {
      document.body.removeChild(script);
    }

    if (widgetElement) {
      document.getElementById('root').removeChild(widgetElement);
    }
  };

  useEffect(() => {
    return () => {
      destroyWidget();
    };
  }, []);

  return {
    initialized,
    init: initWidget,
    destroy: destroyWidget,
  };
};
